export const translations = {
  ar: {
    // General
    "appName": "عرض طلب",
    "loading": "جارٍ التحميل...",
    "login": "تسجيل الدخول",
    "logout": "تسجيل الخروج",
    "loginToContinue": "تسجيل الدخول للمتابعة",
    "usernameOrEmail": "اسم المستخدم أو البريد الإلكتروني",
    "enterUsernameOrEmail": "أدخل اسم المستخدم أو البريد الإلكتروني",
    "loggingIn": "جاري تسجيل الدخول...",
    "loginFailed": "فشل تسجيل الدخول. يرجى المحاولة مرة أخرى.",
    "needHelp": "تحتاج مساعدة؟ اتصل بالمسؤول.",
    "createAccount": "إنشاء حساب",
    "dontHaveAccount": "ليس لديك حساب؟",
    "alreadyHaveAccount": "لديك حساب بالفعل؟",
    "fullName": "الاسم الكامل",
    "enterFullName": "أدخل اسمك الكامل",
    "confirmPassword": "تأكيد كلمة المرور",
    "confirmPasswordPlaceholder": "أعد إدخال كلمة المرور",
    "passwordsDoNotMatch": "كلمات المرور غير متطابقة",
    "passwordMinLength": "يجب أن تكون كلمة المرور 6 أحرف على الأقل",
    "invalidEmail": "يرجى إدخال عنوان بريد إلكتروني صالح",
    "accountCreatedSuccess": "تم إنشاء الحساب بنجاح!",
    "redirectingToLogin": "جاري التوجيه إلى صفحة تسجيل الدخول...",
    "creatingAccount": "جاري إنشاء الحساب...",
    "registrationFailed": "فشل إنشاء الحساب. يرجى المحاولة مرة أخرى.",
    "usernamePattern": "يمكن أن يحتوي اسم المستخدم على أحرف صغيرة وأرقام وشرطة سفلية فقط",
    "usernameHint": "الأحرف الصغيرة والأرقام والشرطة السفلية فقط",
    "surname": "الاسم الأخير",
    "enterSurname": "أدخل اسمك الأخير",
    "tcKimlikNo": "رقم الهوية التركية",
    "enterTCKimlikNo": "أدخل رقم الهوية التركية (11 رقم)",
    "tcKimlikNoHint": "رقم الهوية التركية المكون من 11 رقم",
    "invalidTCKimlikNo": "يرجى إدخال رقم هوية تركي صالح (11 رقم)",
    "tcKimlikNoAlreadyExists": "رقم الهوية التركية موجود بالفعل",
    "enterName": "أدخل اسمك",
    "dashboard": "لوحة التحكم",
    "profile": "الملف الشخصي",
    "settings": "الإعدادات",
    "navigation": "التنقل",
    "requests": "طلباتي",
    "packages": "طرودي",
    "balance": "رصيدي",
    "pricePerKg": "السعر للكيلو",
    "totalKg": "الكيلوغرامات الإجمالية",
    "remainingKg": "الكيلوغرامات المتبقية",
    "unit": "الوحدة",
    "selectUnit": "اختر الوحدة",
    "piece": "قطعة",
    "pieces": "قطع",
    "perKg": "لكل كيلو",
    "perPiece": "لكل قطعة",
    "from": "من",
    "to": "إلى",
    "notes": "ملاحظات",
    "status": "الحالة",
    "actions": "إجراءات",
    "filter": "تصفية",
    "clearFilters": "مسح الفلاتر",
    "office": "المكتب",
    "ofis": "المكتب",
    "ofisler": "المكاتب",
    "ilanlar": "الإعلانات",
    "goingFrom": "من",
    "goingTo": "إلى",
    "allOffices": "جميع المكاتب",
    "allLocations": "جميع المواقع",
    "fromLocation": "من",
    "toLocation": "إلى",
    "viewPosts": "عرض المنشورات",
    "backToOffices": "العودة إلى المكاتب",
    "posts": "المنشورات",
    "search": "بحث",
    "filters": "الفلاتر",
    "sortByDate": "ترتيب حسب التاريخ",
    "sortByPrice": "ترتيب حسب السعر",
    "sortByOffice": "ترتيب حسب المكتب",
    "ascending": "تصاعدي",
    "descending": "تنازلي",
    "fromCity": "من المدينة",
    "toCity": "إلى المدينة",
    "minPrice": "الحد الأدنى للسعر",
    "maxPrice": "الحد الأقصى للسعر",
    "all": "الكل",
    "resultsFound": "نتيجة",
    "submit": "إرسال",
    "approve": "موافقة",
    "reject": "رفض",
    "selectRole": "اختر دورك لتسجيل الدخول",
    "back": "رجوع",
    "noData": "لا توجد بيانات لعرضها.",
    "phoneNumber": "رقم الهاتف",
    "enterPhoneNumber": "أدخل رقم الهاتف (مثال: ‎+905551234567)",
    "phoneNumberHint": "تأكد من إضافة رمز البلد (مثال: ‎+90 لتركيا)",
    "sendCode": "إرسال الرمز",
    "verificationCode": "رمز التحقق",
    "enterVerificationCode": "أدخل رمز التحقق المكوَّن من 6 أرقام المرسل إلى هاتفك",
    "resendCode": "إعادة إرسال الرمز",
    "verifying": "جارٍ التحقق...",
    "sendingCode": "جارٍ إرسال الرمز...",
    "verifyCode": "تحقق من الرمز",
    "recaptchaExpired": "انتهت صلاحية reCAPTCHA. يرجى المحاولة مرة أخرى.",
    "phoneRequired": "رقم الهاتف مطلوب",
    "invalidPhone": "يرجى إدخال رقم هاتف صالح",
    "tooManyRequests": "طلبات كثيرة جداً. يرجى المحاولة مرة أخرى لاحقاً.",
    "failedToSendCode": "فشل إرسال رمز التحقق",
    "verificationCodeRequired": "رمز التحقق مطلوب",
    "noConfirmationResult": "لا توجد نتيجة تأكيد. يرجى طلب رمز جديد.",
    "invalidVerificationCode": "رمز التحقق غير صالح",
    "codeExpired": "انتهت صلاحية رمز التحقق. يرجى طلب رمز جديد.",
    "verificationFailed": "فشل التحقق",
    "phoneAlreadyExists": "رقم الهاتف موجود بالفعل",

    // User Screens
    "availableShipments": "الشحنات المتاحة",
    "shipmentDetails": "تفاصيل الشحنة",
    "requestPackage": "طلب طرد",
    "enterKg": "أدخل الكيلوغرامات التي تريدها",
    "enterPieces": "أدخل عدد القطع التي تريدها",
    "myRequests": "طلباتي",
    "myPackages": "طرودي",
    "myBalance": "رصيدي",
    "requestWithdrawal": "طلب سحب",
    "withdrawalRequests": "طلبات السحب",
    "pendingWithdrawal": "طلب سحب قيد الانتظار",
    "pendingWithdrawalRequests": "طلبات السحب المعلقة",
    "withdrawalRequestDetails": "تفاصيل طلب السحب",
    "review": "مراجعة",
    "addNotes": "إضافة ملاحظات...",
    "selectOffice": "اختر المكتب",
    "transactionHistory": "سجل المعاملات",
    "currentBalance": "الرصيد الحالي",
    "balanceByCurrencyHint": "يتم عرض الأرصدة بشكل منفصل لكل عملة",

    // Admin Screens
    "shipmentPosts": "منشورات الشحن",
    "managePosts": "إدارة المنشورات",
    "managePackages": "إدارة الطرود",
    "createNewPost": "إنشاء منشور جديد",
    "editPost": "تعديل المنشور",
    "userRequests": "طلبات المستخدمين",
    "packageApprovals": "موافقات الطرود",
    "customerApprovals": "موافقات العملاء",
    "generateQR": "إنشاء رمز QR",
    "scanQR": "مسح رمز QR",
    "manageUsers": "إدارة المستخدمين",
    "manageOffices": "إدارة المكاتب",
    "manageWorkers": "إدارة العمال",
    "addOffice": "إضافة مكتب",
    "addWorker": "إضافة عامل",
    "addNewOffice": "إضافة مكتب جديد",
    "addNewWorker": "إضافة عامل جديد",
    "officeName": "اسم المكتب",
    "enterOfficeName": "أدخل اسم المكتب (مثل: مكتب JAC)",
    "offices": "المكاتب",
    "workers": "العمال",
    "noOffices": "لم يتم العثور على مكاتب. قم بإنشاء أول مكتب أعلاه.",
    "noWorkers": "لم يتم العثور على عمال. أضف أول عامل أعلاه.",
    "workersCount": "عدد العمال",
    "maxWorkersReached": "تم الوصول إلى الحد الأقصى (8 عمال). احذف عاملاً لإضافة واحد جديد.",
    "confirmDeleteOffice": "هل أنت متأكد من حذف هذا المكتب؟ سيتم حذف حساب المكتب أيضاً.",
    "confirmDeleteWorker": "هل أنت متأكد من حذف هذا العامل؟",
    "errorCreatingOffice": "خطأ في إنشاء المكتب",
    "errorDeletingOffice": "خطأ في حذف المكتب",
    "errorCreatingWorker": "خطأ في إنشاء العامل",
    "errorDeletingWorker": "خطأ في حذف العامل",
    "username": "اسم المستخدم",
    "password": "كلمة المرور",
    "enterUsername": "أدخل اسم المستخدم",
    "enterPassword": "أدخل كلمة المرور",
    "enterNewPassword": "أدخل كلمة مرور جديدة (اتركها فارغة للاحتفاظ بالحالية)",
    "leavePasswordEmpty": "اتركها فارغة للاحتفاظ بكلمة المرور الحالية",
    "usernameRequired": "اسم المستخدم مطلوب",
    "usernameAndPasswordRequired": "اسم المستخدم وكلمة المرور مطلوبان",
    "setPassword": "تعيين كلمة المرور",
    "setPasswordFor": "تعيين كلمة المرور لـ",
    "passwordRequired": "كلمة المرور مطلوبة",
    "passwordMinLengthHint": "6 أحرف على الأقل",
    "passwordUpdated": "تم تحديث كلمة المرور بنجاح",
    "errorUpdatingPassword": "خطأ في تحديث كلمة المرور",
    "workerNotFound": "لم يتم العثور على العامل",
    "usernameAlreadyExists": "اسم المستخدم موجود بالفعل",
    "editOffice": "تعديل المكتب",
    "edit": "تعديل",
    "update": "تحديث",
    "saving": "جاري الحفظ...",
    "errorUpdatingOffice": "خطأ في تحديث المكتب",
    "officeAdminAccountInfo": "سيؤدي هذا إلى إنشاء حساب مدير مكتب يمكنه إدارة العمال لهذا المكتب.",
    "manageBalances": "إدارة الأرصدة",
    "keyStats": "إحصائيات رئيسية",
    "pendingRequests": "طلبات معلقة",
    "awaitingPickup": "بانتظار الاستلام",
    "deliveredToday": "تم التوصيل اليوم",
    "uploadQRImage": "رفع صورة رمز QR",
    "pasteQRId": "أو الصق معرف QR",
    "enterQRId": "أدخل معرف QR يدوياً",
    "scanResult": "نتيجة المسح",
    "qrCodeId": "معرف رمز QR",
    "clickToCopy": "انقر للنسخ",
    "copied": "تم النسخ!",
    "searchByNameOrEmail": "ابحث بالاسم أو البريد الإلكتروني...",
    "selectUserToViewApprovedPackages": "يرجى اختيار مستخدم لعرض طروده الموافق عليها",
    "pasteQrOrRequestId": "الصق JSON لرمز QR أو معرف الطلب هنا...",
    "pasteQrHint": "يمكنك لصق سلسلة JSON كاملة لرمز QR أو فقط معرف الطلب",
    "noUsersFound": "لم يتم العثور على مستخدمين",
    "noApprovedPackagesFound": "لم يتم العثور على طرود موافق عليها لهذا المستخدم.",
    "qrAlreadyGenerated": "تم إنشاء رمز QR مسبقاً",
    "selectPackageToGenerateQr": "اختر طرداً لإنشاء رمز QR",
    "approvedPackages": "الطرود الموافق عليها",
    "acceptPackage": "قبول الطرد",
    "rejectPackage": "رفض الطرد",
    "flagIssue": "الإبلاغ عن مشكلة",
    "transferPackage": "نقل الطرد",
    "transferTo": "نقل إلى",
    "selectUser": "اختر المستخدم",
    "transfer": "نقل",
    "packageTransferred": "تم نقل الطرد بنجاح",
    "transferPackageTitle": "نقل الطرد إلى مستخدم آخر",
    "pleaseSelectUser": "يرجى اختيار مستخدم",
    "transferFailed": "فشل نقل الطرد",
    "noUsersAvailable": "لا يوجد مستخدمون آخرون متاحون للنقل",
    "manageSellers": "إدارة التجار",
    "sellers": "التجار",
    "accounts": "الحسابات",
    "hesaplar": "الحسابات",
    "sellerName": "اسم التاجر",
    "addSeller": "إضافة تاجر",
    "editSeller": "تعديل التاجر",
    "products": "المنتجات",
    "totalAmount": "المبلغ الإجمالي",
    "totalOwed": "إجمالي المستحقات",
    "postCount": "عدد المنشورات",
    "pricePerPiece": "السعر للقطعة",
    "accountDetails": "تفاصيل الحساب",
    "sellerInformation": "معلومات التاجر",
    "summary": "ملخص",
    "totalPieces": "إجمالي القطع",
    "weightPerPiece": "وزن القطعة",
    "weightPerPiecePlaceholder": "أدخل وزن القطعة بالكيلو",
    "noPosts": "لا توجد منشورات لهذا التاجر",
    "totalPaid": "إجمالي المدفوع",
    "remainingBalance": "الرصيد المتبقي",
    "paymentHistory": "سجل الدفعات",
    "recordedBy": "تم تسجيله بواسطة",
    "paymentNotes": "ملاحظات الدفع",
    "paymentType": "نوع الدفع",
    "before": "قبل",
    "after": "بعد",
    "deductionForMissing": "خصم للـ {unit} الناقصة: {missingAmount} {unit} من الطرد {packageId} (التكلفة: {maliyet} {perUnit})",
    "productName": "اسم المنتج",
    "addProduct": "إضافة منتج",
    "editProduct": "تعديل المنتج",
    "selectSeller": "اختر التاجر",
    "seller": "التاجر",
    "email": "البريد الإلكتروني",
    "phone": "الهاتف",
    "address": "العنوان",
    "description": "الوصف",
    "save": "حفظ",
    "cancel": "إلغاء",
    "selectProduct": "اختر المنتج",
    "selectSellerFirst": "اختر التاجر أولاً",
    "maliyet": "التكلفة",
    "costPerKg": "التكلفة للكيلو",
    "costPerPiece": "التكلفة للقطعة",
    "sellerTransferringPrice": "سعر نقل البائع",
    "packageValueWarning": "في حالة فقدان البضاعة، سيتعين عليك دفع هذا المبلغ",
    "estimatedProfit": "الأرباح المتوقعة",
    "totalProfit": "إجمالي الربح",
    "profitHistory": "تاريخ الأرباح",
    "profit": "الربح",
    "noProfitHistory": "لا يوجد تاريخ أرباح",
    "selectProfilePicture": "اختر صورة الملف الشخصي",
    "emailCannotBeChanged": "لا يمكن تغيير البريد الإلكتروني",
    "phoneCannotBeChanged": "لا يمكن تغيير رقم الهاتف",
    "profileUpdated": "تم تحديث الملف الشخصي بنجاح",
    "nameRequired": "الاسم مطلوب",
    "updateError": "فشل تحديث الملف الشخصي",
    "details": "التفاصيل",
    "transactionDetails": "تفاصيل المعاملة",
    "transactionId": "معرف المعاملة",
    "transactionType": "نوع المعاملة",
    "transactionDate": "تاريخ المعاملة",
    "transactionAmount": "المبلغ",
    "close": "إغلاق",
    "title": "العنوان",
    "message": "الرسالة",

    // Statuses
    "Pending": "معلق",
    "Approved": "موافق عليه",
    "approved": "موافق عليه",
    "Rejected": "مرفوض",
    "processed": "معالج",
    "InTransit": "قيد النقل",
    "Delivered": "تم التوصيل",
    "IssueFlagged": "تم الإبلاغ عن مشكلة",
    "Canceled": "ملغي",
    "Transferred": "تم النقل",
    "Active": "نشط",
    "active": "نشط",
    "Paused": "متوقف مؤقتاً",
    "Completed": "مكتمل",
    "Credit": "إيداع",
    "Withdrawal": "سحب",
    "LostPackage": "طرد مفقود",

    // New Features
    "transactions": "المعاملات",
    "allTransactions": "جميع المعاملات",
    "officeTransactions": "معاملات المكتب",
    "officeCost": "تكلفة المكتب",
    "officeCostOperations": "عمليات تكلفة المكتب",
    "officeCostContent": "سيتم إضافة محتوى تكلفة المكتب هنا.",
    "kasa": "الصندوق",
    "kasaContent": "سيتم إضافة محتوى الصندوق هنا.",
    "kasaHistory": "تاريخ الصندوق",
    "noKasaHistory": "لا يوجد تاريخ للصندوق",
    "type": "النوع",
    "insufficientKasaBalance": "رصيد الصندوق غير كافٍ",
    "kullanicilarinKredileri": "اعتمادات المستخدمين",
    "onlyOfficeViewTransactions": "يمكن لمستخدمي المكتب فقط عرض معاملات المكتب.",
    "activityLog": "سجل الأنشطة",
    "lostPackages": "الطرود المفقودة",
    "reportLostPackage": "الإبلاغ عن طرد مفقود",
    "supportingDocument": "وثيقة داعمة",
    "packageInformation": "معلومات الطرد",
    "viewHistory": "عرض السجل",
    "showQR": "عرض QR",
    "qrPending": "QR قيد الانتظار",
    "qrCode": "رمز QR",
    "packageQRCode": "رمز QR للطرد",
    "noPackagesFound": "لم يتم العثور على طرود",
    "noTransactionsFound": "لم يتم العثور على معاملات",
    "noActivitiesFound": "لم يتم العثور على أنشطة",
    "accessDenied": "تم رفض الوصول",
    "onlySuperAdmin": "فقط المشرف الرئيسي يمكنه الوصول",
    "onlySuperAdminViewTransactions": "فقط المشرف الرئيسي يمكنه عرض جميع المعاملات",
    "onlySuperAdminViewActivityLog": "فقط المشرف الرئيسي يمكنه عرض سجل الأنشطة",
    "onlySuperAdminManageBalances": "فقط المشرف الرئيسي يمكنه إدارة الأرصدة",
    "totalTransactions": "إجمالي المعاملات",
    "totalCredits": "إجمالي الإيداعات",
    "totalWithdrawals": "إجمالي السحوبات",
    "netAmount": "صافي اعتمادات المستخدمين",
    "allTypes": "جميع الأنواع",
    "creditsOnly": "الإيداعات فقط",
    "withdrawalsOnly": "السحوبات فقط",
    "searchByUser": "البحث بالاسم، الوصف، أو معرف المعاملة...",
    "searchByActivity": "البحث بالاسم، الوصف، أو نوع النشاط...",
    "totalActivities": "إجمالي الأنشطة",
    "approvals": "الموافقات",
    "deliveries": "التسليمات",
    "qrCodesGenerated": "رموز QR المولدة",
    "allActivities": "جميع الأنشطة",
    "activityType": "نوع النشاط",
    "performedBy": "نفذ بواسطة",
    "targetUser": "المستخدم المستهدف",
    "relatedPackage": "الطرد المرتبط",
    "relatedShipment": "الشحنة المرتبطة",
    "additionalDetails": "تفاصيل إضافية",
    "timestamp": "الطابع الزمني",
    "requestApproved": "تمت الموافقة على الطلب",
    "requestRejected": "تم رفض الطلب",
    "packageDelivered": "تم تسليم الطرد",
    "qrGenerated": "تم إنشاء QR",
    "statusChanged": "تم تغيير الحالة",
    "lostReportApproved": "تمت الموافقة على تقرير المفقود",
    "lostReportRejected": "تم رفض تقرير المفقود",
    "postCreated": "تم إنشاء المنشور",
    "postUpdated": "تم تحديث المنشور",
    "userCreated": "تم إنشاء المستخدم",
    "balanceAdjusted": "تم تعديل الرصيد",
    "lostPackageReportApproved": "تمت الموافقة على تقرير الطرد المفقود - تم خصم الرصيد",
    "lostPackageReportPending": "تقرير الطرد المفقود قيد المراجعة",
    "cannotTransferPackage": "لا يمكن نقل الطرد: تمت الموافقة على تقرير الطرد المفقود وتم خصم الرصيد",
    "warning": "تحذير",
    "ifReportApproved": "إذا تمت الموافقة على تقريرك، سيتم خصم قيمة الطرد (${amount}) من رصيدك.",
    "packageId": "معرف الطرد",
    "requestId": "معرف الطلب",
    "weight": "الوزن",
    "route": "المسار",
    "packageValue": "قيمة الطرد",
    "processedRequests": "الطلبات المعالجة",
    "reportedAt": "تاريخ الإبلاغ",
    "reviewedAt": "تاريخ المراجعة",
    "adminNotes": "ملاحظات المشرف",
    "optional": "اختياري",
    "uploadPDF": "قم بتحميل ملف PDF أو مستند Word (.doc, .docx) أو ملف نصي (.txt). الحد الأقصى للحجم: 10MB",
    "clickToUpload": "انقر للتحميل أو اسحب وأفلت",
    "orDragAndDrop": "أو اسحب وأفلت",
    "takePicture": "التقاط صورة",
    "maxFileSize": "PDF، DOC، DOCX، TXT (حد أقصى 10MB)",
    "fileTooLarge": "حجم الملف يجب أن يكون أقل من 10MB",
    "attachment": "مرفق",
    "viewAttachment": "عرض المرفق",
    "noOfficesFound": "لم يتم العثور على مكاتب",
    "maxSize": "PDF، DOC، DOCX أو TXT (الحد الأقصى 10MB)",
    "submitting": "جاري الإرسال...",
    "submitReport": "إرسال التقرير",
    "lostPackageReportDetails": "تفاصيل تقرير الطرد المفقود",
    "reportId": "معرف التقرير",
    "user": "المستخدم",
    "packageDetails": "تفاصيل الطرد",
    "viewRequest": "عرض طلب",
    "approveDeductBalance": "الموافقة وخصم الرصيد",
    "processing": "جاري المعالجة...",
    "totalUsers": "إجمالي المستخدمين",
    "totalSystemBalance": "إجمالي رصيد النظام",
    "transactionSummary": "ملخص المعاملة",
    "creditExplanation": "تمت إضافة هذا الائتمان إلى رصيدك عند تسليم طردك.",
    "withdrawalExplanation": "تم خصم هذا المبلغ من رصيدك. قد يكون هذا بسبب الموافقة على تقرير طرد مفقود أو إجراء إداري آخر.",
    "routeLabel": "المسار",
    "packageIdLabel": "معرف الطرد",
    "weightLabel": "الوزن",
    "pricePerKgLabel": "السعر للكيلو",
    "packageValueLabel": "قيمة الطرد",
    "statusLabel": "الحالة",
    "lostPackageReport": "تقرير الطرد المفقود",
    "balanceDeducted": "تم خصم الرصيد",
    "kg": "كجم",
    "receivedKg": "المستلم",
    "moreInfo": "مزيد من المعلومات",
    "userEmail": "البريد الإلكتروني للمستخدم",
    "currentBalanceLabel": "الرصيد الحالي",
    "actionsLabel": "الإجراءات",
    "downloadFile": "تحميل الملف",
    "pleaseProvideDescription": "يرجى تقديم وصف",
    "failedToReportLostPackage": "فشل الإبلاغ عن الطرد المفقود. يرجى المحاولة مرة أخرى.",
    "pendingReportExists": "يوجد بالفعل تقرير معلق لهذا الطرد",
    "role": "الدور",
    "system": "النظام",
    "transferring": "جاري النقل...",
    "cannotTransferLostPackage": "لا يمكن نقل الطرد: تمت الموافقة على تقرير الطرد المفقود وتم خصم الرصيد.",
    "showQRCodeToReceiver": "اعرض رمز QR هذا للمستلم",
    "receiverInstructions": "المستلم: امسح رمز QR المعروض أعلاه",
    "openCamera": "فتح الكاميرا لمسح رمز QR",
    "qrCodeScanned": "تم مسح رمز QR بنجاح!",
    "giverConfirmation": "تأكيد المانح",
    "receiverConfirmation": "تأكيد المستلم",
    "confirmYouAreGiving": "أكد أنك تعطي هذا الطرد",
    "confirmYouAreReceiving": "أكد أنك تستلم هذا الطرد",
    "scanQRCode": "مسح رمز QR",
    "cameraAccessError": "فشل الوصول إلى الكاميرا. يرجى السماح بأذونات الكاميرا.",
    "packageNotForYou": "هذا الطرد لا ينتمي إليك.",
    "invalidQRCode": "تنسيق رمز QR غير صالح.",
    "receivePackage": "استقبال الطرد",
    "scanQRCodeToReceive": "امسح رمز QR المعروض من قبل الشخص الذي ينقل الطرد",
    "packageToReceive": "الطرد المراد استقباله:",
    "receive": "استقبال الطرد",
    "packageAlreadyYours": "هذا الطرد ملكك بالفعل.",
    "cannotReceiveLostPackage": "لا يمكن استقبال طرد تم الإبلاغ عنه كمفقود.",
    "packageNotFound": "الطرد غير موجود.",
    "confirmPackageTransfer": "تأكيد نقل الطرد",
    "transferFrom": "النقل من:",
    "unknownUser": "مستخدم غير معروف",
    "pleaseConfirmTransfer": "يرجى تأكيد النقل أولاً.",
    "waitingForConfirmation": "يرجى انتظار شاشة التأكيد...",
    "completeTransfer": "إكمال النقل",
    "transferringTo": "النقل إلى:",
    "yourConfirmation": "تأكيدك",
    "waiting": "في الانتظار...",
    "transferCompleted": "تم النقل! سيتم نقل الطرد قريباً.",
    "transferAlreadyPending": "يوجد نقل معلق بالفعل لهذا الطرد.",
    "failedToCreateTransfer": "فشل إنشاء طلب النقل.",
    "failedToCancelTransfer": "فشل إلغاء النقل.",
    "transferredFrom": "تم النقل من",
    "transferredTo": "تم النقل إلى",
    "transferredAt": "تاريخ النقل",
    "transferredBy": "نقل بواسطة",
    "scanQRCodeInstructions": "وجه الكاميرا إلى رمز QR للمسح",
    "onlyOfficeCanAcceptPackage": "فقط المكتب الذي أنشأ رمز QR هذا يمكنه قبول الطرد.",
    "packageBelongsToDifferentOffice": "الطرد ينتمي إلى مكتب مختلف",
    "packageBelongsToOfficeMessage": "هذا الطرد ينتمي إلى مكتب مختلف ولا يمكن قبوله هنا.",
    "thisPackageBelongsTo": "هذا الطرد ينتمي إلى",
    "pleaseContactCorrectOffice": "يرجى الاتصال بالمكتب الصحيح لقبول هذا الطرد.",
    "packageFound": "تم العثور على الطرد:",
    "confirm": "تأكيد",
    "containerNumber": "رقم الحاوية",
    "notSpecified": "غير محدد",
    "activePackages": "الطرود النشطة",
    "archive": "الأرشيف",
    "archived": "مؤرشف",
    "noActivePackages": "لا توجد طرود نشطة",
    "noActivePackagesDescription": "ليس لديك أي طرود نشطة في الوقت الحالي.",
    "noArchivedPackages": "لا توجد طرود مؤرشفة",
    "noArchivedPackagesDescription": "ليس لديك أي طرود مؤرشفة.",
    "inTransit": "قيد النقل",
    "delivered": "تم التسليم",
    "workerActions": "إجراءات العامل",
    "approvedBy": "تمت الموافقة بواسطة",
    "acceptedBy": "قبل بواسطة",
    "qrGeneratedBy": "تم إنشاء QR بواسطة",
    "deliveredBy": "تم التسليم بواسطة",
    "info": "معلومات",
    "postDetails": "تفاصيل الإعلان",
    "shipmentInformation": "معلومات الشحنة",
    "shipment": "الشحنة",
    "viewDetails": "عرض التفاصيل",
    "customers": "العملاء",
    "noCustomers": "لا يوجد عملاء لهذا الإعلان بعد.",
    "scanDate": "تاريخ المسح",
    "dateTime": "التاريخ والوقت",
    "delete": "حذف",
    "deleteSeller": "حذف التاجر",
    "deleteProduct": "حذف المنتج",
    "deletePost": "حذف المنشور",
    "confirmDelete": "تأكيد الحذف",
    "confirmDeleteSeller": "هل أنت متأكد من حذف هذا التاجر؟ لا يمكن التراجع عن هذا الإجراء.",
    "confirmDeleteProduct": "هل أنت متأكد من حذف هذا المنتج؟ لا يمكن التراجع عن هذا الإجراء.",
    "confirmDeletePost": "هل أنت متأكد من حذف هذا المنشور؟ لا يمكن التراجع عن هذا الإجراء.",
    "deletedSuccessfully": "تم الحذف بنجاح",
    "failedToDelete": "فشل الحذف. يرجى المحاولة مرة أخرى.",
    "yes": "نعم",
    "no": "لا",
    "areYouSure": "هل أنت متأكد؟",
    "name": "الاسم",
    "createdAt": "تاريخ الإنشاء",
    "enterEmail": "أدخل بريدك الإلكتروني",
    "create": "إنشاء",
    "creating": "جاري الإنشاء...",
    "fillAllFields": "يرجى ملء جميع الحقول المطلوبة",
    "emailAlreadyExists": "البريد الإلكتروني موجود بالفعل",
    "amount": "المبلغ",
    "addIncome": "إضافة دخل",
    "withdraw": "سحب",
    "pleaseEnterValidAmount": "يرجى إدخال مبلغ صالح",
    "failedToWithdraw": "فشل السحب",
    "failedToAddIncome": "فشل إضافة الدخل",
    "balanceByOffice": "الرصيد حسب المكتب",
    "noBalanceAvailable": "لا يوجد رصيد متاح للسحب",
    "insufficientBalance": "الرصيد غير كافٍ",
    "pendingWithdrawalExists": "لديك بالفعل طلب سحب قيد الانتظار لهذا المكتب",
    "noBalanceForOffice": "لا يوجد رصيد متاح لهذا المكتب",
    "noShipmentsFound": "لم يتم العثور على شحنات",
    "noPostsFound": "لم يتم العثور على منشورات",
    "postNotFound": "لم يتم العثور على المنشور",
    "print": "طباعة",
    "loadingPackageInformation": "جارٍ تحميل معلومات الطرد...",
    "error": "خطأ",
    "packageInfoNotFound": "لم يتم العثور على معلومات الطرد.",
    "statusHistory": "سجل الحالة",
    "packageInfoConfidentialNote": "يحتوي هذا المستند على معلومات سرية عن الطرد.",
    "exportPdf": "تصدير PDF",
    "customerInformation": "معلومات العميل",
    "imageUploadHint": "PNG، JPG، GIF حتى 10MB",
    "date": "التاريخ",
    "noSellersFound": "لم يتم العثور على تجار",
    "remainingPieces": "القطع المتبقية",
    "requestApproval": "طلب الموافقة على الحساب",
    "approvalRequired": "الموافقة على الحساب مطلوبة",
    "approvalRequiredDescription": "يحتاج حسابك إلى موافقة من مكتب قبل أن تتمكن من استخدام التطبيق. يرجى اختيار مكتب وإرسال طلب الموافقة.",
    "submitApprovalRequest": "إرسال طلب الموافقة",
    "selectAnOffice": "اختر مكتب...",
    "pleaseSelectOffice": "يرجى اختيار مكتب",
    "pendingRequestExists": "لديك بالفعل طلب معلق لهذا المكتب",
    "pendingRequestForOffice": "لديك بالفعل طلب معلق لهذا المكتب",
    "errorSubmittingRequest": "حدث خطأ أثناء إرسال الطلب",
    "requestSubmittedSuccessfully": "تم إرسال الطلب بنجاح! سيقوم المكتب بمراجعة طلبك.",
    "messagePlaceholder": "أضف أي معلومات إضافية تريد تضمينها مع طلبك...",
    "submitRequest": "إرسال الطلب",
    "myApprovalRequests": "طلبات الموافقة الخاصة بي",
    "submitted": "تم الإرسال",
    "reviewed": "تمت المراجعة",
    "shortageDelivery": "تسليم ناقص",
    "missingWeight": "الوزن الناقص",
    "deductFromBalance": "خصم من الرصيد",
    "putOnHold": "وضع في الانتظار",
    "deliverMissingWeight": "تسليم الكمية الناقصة",
    "shortageDeliveryNotification": "إشعار تسليم ناقص: {missingKg} كجم ناقص",
    "selectAction": "اختر الإجراء",
    "waitingForMissingWeight": "في انتظار الكمية الناقصة",
    "missingWeightDelivered": "تم تسليم الكمية الناقصة",
    "payUpfront": "دفع مقدم",
    "mutualApprovalRequired": "الموافقة المتبادلة مطلوبة",
    "shortageDeliveryDetails": "تفاصيل التسليم الناقص",
    "requestedWeight": "الوزن المطلوب",
    "receivedWeight": "الوزن المستلم",
    "missingAmount": "الكمية الناقصة",
    "shortageStatus": "الحالة",
    "sendingOffice": "المكتب المرسل",
    "receivingOffice": "المكتب المستقبل",
    "actionTaken": "الإجراء المتخذ",
    "missingKgDelivered": "الكمية الناقصة المسلمة",
    "deliveredAt": "تاريخ التسليم",
    "finalAction": "الإجراء النهائي",
    "noShortageDeliveries": "لا توجد تسليمات ناقصة",
    "enterMissingWeight": "أدخل الكمية الناقصة (كجم)",
    "deliver": "تسليم",
    "cannotDeliverMoreThanMissing": "لا يمكن تسليم أكثر من الكمية الناقصة",
    "shortageActionConfirmation": "هل تريد تأكيد هذا الإجراء؟",
    "deductConfirmation": "سيتم خصم الكمية الناقصة من الرصيد. هل تريد المتابعة؟",
    "holdConfirmation": "سيتم وضع الحزمة في الانتظار وانتظار إحضار الكمية الناقصة. هل تريد المتابعة؟",
    "finalActionConfirmation": "هل تريد تأكيد هذا الإجراء النهائي؟",
    "pending": "قيد الانتظار",
    "onHold": "في الانتظار",
    "paidUpfront": "تم الدفع مقدم",
    "completed": "تم",
    "rejected": "مرفوض",
    "selectShortageAction": "كيف تريد التعامل مع المبلغ الناقص؟",
    "qrCodeWarning": "تم إنشاء هذه الوثيقة من رمز QR ممسوح ضوئياً. يرجى التحقق من جميع المعلومات قبل المعالجة.",
    "createManualPackage": "إنشاء طرد يدوي",
    "createAndGenerateQR": "إنشاء وإنشاء رمز QR",
    "enterWeight": "أدخل الوزن (كجم)",
    "requestedPieces": "القطع المطلوبة",
    "requestedKg": "الوزن المطلوب (كجم)",
    "pleaseEnterValidWeight": "يرجى إدخال وزن صالح",
    "pleaseEnterNameAndPhone": "يرجى إدخال الاسم ورقم الهاتف",
    "errorCreatingPackage": "خطأ في إنشاء الطرد",
    "packageCreatedSuccessfully": "تم إنشاء الطرد بنجاح!",
    "qrCodeGenerated": "تم إنشاء رمز QR والطرد جاهز.",
    "bagNumber": "رقم الكيس",
    "enterBagNumber": "أدخل رقم الكيس",
    "manageNotifications": "إدارة الإشعارات",
    "sendNotification": "إرسال إشعار",
    "notificationTitle": "عنوان الإشعار",
    "notificationMessage": "رسالة الإشعار",
    "target": "الهدف",
    "sending": "جاري الإرسال...",
    "notifications": "الإشعارات",
    "unread": "غير مقروء",
    "noNotifications": "لا توجد إشعارات",
    "markAsRead": "تعليم كمقروء",
    "justNow": "الآن",
    "minutesAgo": "دقيقة مضت",
    "hoursAgo": "ساعة مضت",
    "daysAgo": "يوم مضى",
    "userApprovals": "موافقات المستخدمين",
    "more": "المزيد",
    "expectedWeight": "المتوقع",
    "receivedWeightHint": "أدخل الوزن المستلم فعلياً. إذا لم يُحدد، سيتم استخدام الوزن المتوقع.",
    "packageRequestApproved": "تمت الموافقة على طلب الطرد",
    "packageRequestRejected": "تم رفض طلب الطرد",
    "packageMarkedAsDelivered": "تم تسليم الطرد",
    "qrCodeGeneratedForPackage": "تم إنشاء رمز QR للطرد",
    "packageCanceledLostReportApproved": "تم إلغاء الطرد - تمت الموافقة على بلاغ الفقدان",
    "packageTransferredToAnotherUser": "تم نقل الطرد إلى مستخدم آخر",
    "packageStatusChangedTo": "تم تغيير حالة الطرد إلى",
    "package": "طرد",
    "lostPackageReportRejected": "تم رفض بلاغ الطرد المفقود",
    "shipmentPostCreated": "تم إنشاء إعلان شحن",
    "lost": "مفقود",
    "post": "الإعلان",
    "errorProcessingRequest": "حدث خطأ أثناء معالجة الطلب",
    "unknownOffice": "مكتب غير معروف",
    "approveUserRequest": "الموافقة على طلب المستخدم",
    "rejectUserRequest": "رفض طلب المستخدم",
    "noProcessedRequests": "لا توجد طلبات معالجة",
    "recordPayment": "تسجيل دفعة",
    "noPaymentsFound": "لم يتم العثور على مدفوعات",
    "invalidAmount": "يرجى إدخال مبلغ صالح",
    "amountExceedsBalance": "لا يمكن أن يتجاوز مبلغ الدفع الرصيد المتبقي",
    "paymentRecorded": "تم تسجيل الدفعة بنجاح!",
    "paymentFailed": "تعذر تسجيل الدفعة. يرجى المحاولة مرة أخرى",
    "paymentAmount": "مبلغ الدفعة",
    "paymentDescriptionPlaceholder": "أضف ملاحظات حول هذه الدفعة...",
    "productDetails": "تفاصيل المنتج",
    "productInformation": "معلومات المنتج",
    "archivedAt": "تاريخ الأرشفة",
    "manageUserApprovals": "إدارة موافقات المستخدمين",
    "enterWorkerName": "أدخل اسم الموظف",
    "searchTransactions": "البحث في المعاملات...",
    "amountExceedsDebt": "المبلغ يتجاوز الدين المتبقي",
    "pleaseEnterDescription": "يرجى إدخال وصف",
    "failedToMarkDelivered": "تعذر وضع علامة تم التسليم",
    "failedToGeneratePdf": "تعذر إنشاء ملف PDF",
    "generatedOn": "تاريخ الإنشاء",
    "withdrawal": "سحب",
    "lostPackage": "طرد مفقود",
    "currency": "العملة",
    "cameraNotSupported": "الكاميرا غير مدعومة على هذا الجهاز",
    "cameraRequiresHttps": "يتطلب الوصول إلى الكاميرا اتصالاً آمناً (HTTPS)",
    "swapLocations": "تبديل المواقع"
  },
  tr: {
    // General
    "appName": "arztaleb",
    "loading": "Yükleniyor...",
    "login": "Giriş Yap",
    "logout": "Çıkış Yap",
    "loginToContinue": "Devam etmek için giriş yapın",
    "usernameOrEmail": "Kullanıcı Adı veya E-posta",
    "enterUsernameOrEmail": "Kullanıcı adınızı veya e-postanızı girin",
    "loggingIn": "Giriş yapılıyor...",
    "loginFailed": "Giriş başarısız. Lütfen tekrar deneyin.",
    "needHelp": "Yardıma mı ihtiyacınız var? Yöneticinizle iletişime geçin.",
    "createAccount": "Hesap Oluştur",
    "dontHaveAccount": "Hesabınız yok mu?",
    "alreadyHaveAccount": "Zaten hesabınız var mı?",
    "fullName": "Ad Soyad",
    "enterFullName": "Adınızı ve soyadınızı girin",
    "confirmPassword": "Şifreyi Onayla",
    "confirmPasswordPlaceholder": "Şifrenizi tekrar girin",
    "passwordsDoNotMatch": "Şifreler eşleşmiyor",
    "passwordMinLength": "Şifre en az 6 karakter olmalıdır",
    "invalidEmail": "Lütfen geçerli bir e-posta adresi girin",
    "accountCreatedSuccess": "Hesap başarıyla oluşturuldu!",
    "redirectingToLogin": "Giriş sayfasına yönlendiriliyor...",
    "creatingAccount": "Hesap oluşturuluyor...",
    "registrationFailed": "Hesap oluşturulamadı. Lütfen tekrar deneyin.",
    "usernamePattern": "Kullanıcı adı yalnızca küçük harf, rakam ve alt çizgi içerebilir",
    "usernameHint": "Yalnızca küçük harf, rakam ve alt çizgi",
    "surname": "Soyad",
    "enterSurname": "Soyadınızı girin",
    "tcKimlikNo": "T.C. Kimlik No",
    "enterTCKimlikNo": "T.C. Kimlik Numaranızı girin (11 haneli)",
    "tcKimlikNoHint": "11 haneli Türkiye Cumhuriyeti Kimlik Numarası",
    "invalidTCKimlikNo": "Lütfen geçerli bir T.C. Kimlik No girin (11 haneli)",
    "tcKimlikNoAlreadyExists": "T.C. Kimlik No zaten mevcut",
    "enterName": "Adınızı girin",
    "dashboard": "Kontrol Paneli",
    "profile": "Profil",
    "settings": "Ayarlar",
    "navigation": "Navigasyon",
    "requests": "Taleplerim",
    "packages": "Paketlerim",
    "balance": "Bakiyem",
    "pricePerKg": "Taşıma Ücreti",
    "totalKg": "Toplam Kg",
    "remainingKg": "Kalan Kg",
    "unit": "Birim",
    "selectUnit": "Birim Seç",
    "piece": "Adet",
    "pieces": "Adet",
    "perKg": "kg başına",
    "perPiece": "adet başına",
    "from": "Nereden",
    "to": "Nereye",
    "notes": "Taşıtıcı Notları",
    "status": "Durum",
    "actions": "İşlemler",
    "filter": "Filtrele",
    "clearFilters": "Filtreleri Temizle",
    "office": "Ofis",
    "ofis": "Ofis",
    "ofisler": "Ofisler",
    "ilanlar": "İlanlar",
    "goingFrom": "Nereden",
    "goingTo": "Nereye",
    "allOffices": "Tüm Ofisler",
    "allLocations": "Tüm Konumlar",
    "fromLocation": "Nereden",
    "toLocation": "Nereye",
    "viewPosts": "Gönderileri Görüntüle",
    "backToOffices": "Ofislere Dön",
    "posts": "Gönderiler",
    "search": "Ara",
    "filters": "Filtreler",
    "sortByDate": "Tarihe Göre Sırala",
    "sortByPrice": "Fiyata Göre Sırala",
    "sortByOffice": "Ofise Göre Sırala",
    "ascending": "Artan",
    "descending": "Azalan",
    "fromCity": "Nereden Şehir",
    "toCity": "Nereye Şehir",
    "minPrice": "Minimum Fiyat",
    "maxPrice": "Maksimum Fiyat",
    "all": "Tümü",
    "resultsFound": "sonuç bulundu",
    "submit": "Gönder",
    "approve": "Onayla",
    "reject": "Reddet",
    "selectRole": "Giriş yapmak için rolünüzü seçin",
    "back": "Geri",
    "noData": "Görüntülenecek veri yok.",
    "phoneNumber": "Telefon Numarası",
    "enterPhoneNumber": "Telefon numaranızı girin (örn. +905551234567)",
    "phoneNumberHint": "Ülke kodunu eklediğinizden emin olun (örn. Türkiye için +90)",
    "sendCode": "Kod Gönder",
    "verificationCode": "Doğrulama Kodu",
    "enterVerificationCode": "Telefonunuza gönderilen 6 haneli kodu girin",
    "resendCode": "Kodu tekrar gönder",
    "verifying": "Doğrulanıyor...",
    "sendingCode": "Kod gönderiliyor...",
    "verifyCode": "Kodu Doğrula",
    "recaptchaExpired": "reCAPTCHA süresi doldu. Lütfen tekrar deneyin.",
    "phoneRequired": "Telefon numarası gerekli",
    "invalidPhone": "Lütfen geçerli bir telefon numarası girin",
    "tooManyRequests": "Çok fazla istek gönderildi. Lütfen daha sonra tekrar deneyin.",
    "failedToSendCode": "Doğrulama kodu gönderilemedi",
    "verificationCodeRequired": "Doğrulama kodu gerekli",
    "noConfirmationResult": "Onay sonucu yok. Lütfen yeni bir kod isteyin.",
    "invalidVerificationCode": "Geçersiz doğrulama kodu",
    "codeExpired": "Doğrulama kodunun süresi doldu. Lütfen yeni bir kod isteyin.",
    "verificationFailed": "Doğrulama başarısız oldu",
    "phoneAlreadyExists": "Telefon numarası zaten mevcut",

    // User Screens
    "availableShipments": "Mevcut Gönderiler",
    "shipmentDetails": "Gönderi Detayları",
    "requestPackage": "Paket Talep Et",
    "enterKg": "İstediğiniz kilogramı girin",
    "enterPieces": "İstediğiniz adedi girin",
    "myRequests": "Taleplerim",
    "myPackages": "Paketlerim",
    "myBalance": "Bakiyem",
    "requestWithdrawal": "Para Çekme Talebi",
    "withdrawalRequests": "Para Çekme Talepleri",
    "pendingWithdrawal": "Bekleyen para çekme talebi",
    "pendingWithdrawalRequests": "bekleyen para çekme talebi",
    "withdrawalRequestDetails": "Para Çekme Talebi Detayları",
    "review": "İncele",
    "addNotes": "Not ekle...",
    "selectOffice": "Ofis Seç",
    "transactionHistory": "İşlem Geçmişi",
    "currentBalance": "Mevcut Bakiye",
    "balanceByCurrencyHint": "Bakiyeler para birimine göre ayrı ayrı gösterilir",

    // Admin Screens
    "shipmentPosts": "Gönderi İlanları",
    "managePosts": "İlanları Yönet",
    "managePackages": "Paketleri Yönet",
    "createNewPost": "Yeni İlan Oluştur",
    "editPost": "İlanı Düzenle",
    "userRequests": "Kullanıcı Talepleri",
    "packageApprovals": "Paket Onayları",
    "customerApprovals": "Müşteri Onayları",
    "generateQR": "QR Kod Oluştur",
    "scanQR": "QR Kod Tara",
    "manageUsers": "Kullanıcıları Yönet",
    "manageOffices": "Ofisleri Yönet",
    "manageWorkers": "Çalışanları Yönet",
    "addOffice": "Ofis Ekle",
    "addWorker": "Çalışan Ekle",
    "addNewOffice": "Yeni Ofis Ekle",
    "addNewWorker": "Yeni Çalışan Ekle",
    "officeName": "Ofis Adı",
    "enterOfficeName": "Ofis adını girin (örn: JAC Ofisi)",
    "offices": "Ofisler",
    "workers": "Çalışanlar",
    "noOffices": "Ofis bulunamadı. Yukarıdan ilk ofisinizi oluşturun.",
    "noWorkers": "Çalışan bulunamadı. Yukarıdan ilk çalışanınızı ekleyin.",
    "workersCount": "Çalışan Sayısı",
    "maxWorkersReached": "Maksimum 8 çalışana ulaşıldı. Yeni bir tane eklemek için bir çalışanı silin.",
    "confirmDeleteOffice": "Bu ofisi silmek istediğinizden emin misiniz? Ofis hesabı da silinecektir.",
    "confirmDeleteWorker": "Bu çalışanı silmek istediğinizden emin misiniz?",
    "errorCreatingOffice": "Ofis oluşturulurken hata",
    "errorDeletingOffice": "Ofis silinirken hata",
    "errorCreatingWorker": "Çalışan oluşturulurken hata",
    "errorDeletingWorker": "Çalışan silinirken hata",
    "username": "Kullanıcı Adı",
    "password": "Şifre",
    "enterUsername": "Kullanıcı adını girin",
    "enterPassword": "Şifreyi girin",
    "enterNewPassword": "Yeni şifre girin (mevcut şifreyi korumak için boş bırakın)",
    "leavePasswordEmpty": "Mevcut şifreyi korumak için boş bırakın",
    "usernameRequired": "Kullanıcı adı gerekli",
    "usernameAndPasswordRequired": "Kullanıcı adı ve şifre gerekli",
    "usernameAlreadyExists": "Kullanıcı adı zaten mevcut",
    "setPassword": "Şifre Belirle",
    "setPasswordFor": "İçin Şifre Belirle",
    "passwordRequired": "Şifre gerekli",
    "passwordMinLengthHint": "En az 6 karakter",
    "passwordUpdated": "Şifre başarıyla güncellendi",
    "errorUpdatingPassword": "Şifre güncellenirken hata",
    "workerNotFound": "Çalışan bulunamadı",
    "editOffice": "Ofisi Düzenle",
    "edit": "Düzenle",
    "update": "Güncelle",
    "saving": "Kaydediliyor...",
    "errorUpdatingOffice": "Ofis güncellenirken hata",
    "officeAdminAccountInfo": "Bu, bu ofis için çalışanları yönetebilecek bir ofis yönetici hesabı oluşturacaktır.",
    "manageBalances": "Bakiyeleri Yönet",
    "keyStats": "Önemli İstatistikler",
    "pendingRequests": "Bekleyen Talepler",
    "awaitingPickup": "Teslim Alınmayı Bekleyenler",
    "deliveredToday": "Bugün Teslim Edilenler",
    "uploadQRImage": "QR Kod Resmini Yükle",
    "pasteQRId": "veya QR ID Yapıştır",
    "enterQRId": "QR ID'yi Manuel Olarak Girin",
    "scanResult": "Tarama Sonucu",
    "qrCodeId": "QR Kod ID",
    "clickToCopy": "Kopyalamak için tıklayın",
    "copied": "Kopyalandı!",
    "searchByNameOrEmail": "İsim veya e-posta ile ara...",
    "selectUserToViewApprovedPackages": "Onaylı paketlerini görmek için lütfen bir kullanıcı seçin",
    "pasteQrOrRequestId": "QR kod JSON'unu veya Talep ID'sini buraya yapıştırın...",
    "pasteQrHint": "Tam QR kodu JSON metnini veya sadece Talep ID'sini yapıştırabilirsiniz",
    "noUsersFound": "Kullanıcı bulunamadı",
    "noApprovedPackagesFound": "Bu kullanıcı için onaylı paket bulunamadı.",
    "qrAlreadyGenerated": "QR kod zaten oluşturuldu",
    "selectPackageToGenerateQr": "QR kod oluşturmak için bir paket seçin",
    "approvedPackages": "Onaylı Paketler",
    "acceptPackage": "Paketi Kabul Et",
    "rejectPackage": "Paketi Reddet",
    "flagIssue": "Sorun Bildir",
    "receivedWeight": "Alınan Ağırlık (kg)",
    "expectedWeight": "Beklenen",
    "receivedWeightHint": "Gerçekte alınan ağırlığı girin. Belirtilmezse beklenen ağırlık kullanılacaktır.",
    "received": "alınan",
    "transferPackage": "Paketi Aktar",
    "transferTo": "Aktar",
    "selectUser": "Kullanıcı Seç",
    "transfer": "Aktar",
    "packageTransferred": "Paket başarıyla aktarıldı",
    "transferPackageTitle": "Paketi Başka Kullanıcıya Aktar",
    "pleaseSelectUser": "Lütfen bir kullanıcı seçin",
    "transferFailed": "Paket aktarımı başarısız",
    "noUsersAvailable": "Aktarım için başka kullanıcı mevcut değil",
    "manageSellers": "Tüccarları Yönet",
    "sellers": "Tüccarlar",
    "accounts": "Hesaplar",
    "hesaplar": "Hesaplar",
    "sellerName": "Tüccar Adı",
    "addSeller": "Tüccar Ekle",
    "editSeller": "Tüccarı Düzenle",
    "products": "Ürünler",
    "totalAmount": "Toplam Tutar",
    "totalOwed": "Toplam Borç",
    "postCount": "İlan Sayısı",
    "pricePerPiece": "Parça Başına Fiyat",
    "accountDetails": "Hesap Detayları",
    "sellerInformation": "Tüccar Bilgileri",
    "summary": "Özet",
    "totalPieces": "Toplam Adet",
    "weightPerPiece": "Parça Ağırlığı",
    "weightPerPiecePlaceholder": "Parça ağırlığını kg cinsinden girin",
    "noPosts": "Bu tüccar için ilan bulunamadı",
    "totalPaid": "Toplam Ödenen",
    "remainingBalance": "Kalan Bakiye",
    "recordPayment": "Ödeme Kaydet",
    "paymentHistory": "Ödeme Geçmişi",
    "recordedBy": "Kaydeden",
    "paymentNotes": "Ödeme Notları",
    "noPayments": "Henüz ödeme kaydı yok",
    "paymentAmount": "Ödeme Tutarı",
    "paymentDescriptionPlaceholder": "Bu ödeme hakkında notlar ekleyin...",
    "invalidAmount": "Lütfen geçerli bir tutar girin",
    "amountExceedsBalance": "Ödeme tutarı kalan bakiyeyi aşamaz",
    "paymentRecorded": "Ödeme başarıyla kaydedildi!",
    "paymentFailed": "Ödeme kaydedilemedi. Lütfen tekrar deneyin",
    "paymentType": "Ödeme Tipi",
    "before": "Önce",
    "after": "Sonra",
    "deductionForMissing": "Eksik {unit} için kesinti: {missingAmount} {unit} paket {packageId} (maliyet: {maliyet} {perUnit})",
    "productName": "Ürün Adı",
    "addProduct": "Ürün Ekle",
    "editProduct": "Ürünü Düzenle",
    "selectSeller": "Tüccar Seç",
    "seller": "Tüccar",
    "email": "E-posta",
    "phone": "Telefon",
    "address": "Adres",
    "description": "Açıklama",
    "save": "Kaydet",
    "cancel": "İptal",
    "selectProduct": "Ürün Seç",
    "selectSellerFirst": "Önce Tüccar Seçin",
    "maliyet": "Maliyet",
    "costPerKg": "Kg Başına Maliyet",
    "sellerTransferringPrice": "Satıcı Transfer Fiyatı",
    "costPerPiece": "Adet Başına Maliyet",
    "packageValueWarning": "Malın kaybolduğu halde bu tutarı ödemek zorunda olacaksınız",
    "estimatedProfit": "Tahmini Kar",
    "totalProfit": "Toplam Kar",
    "profitHistory": "Kar Geçmişi",
    "profit": "Kar",
    "noProfitHistory": "Kar geçmişi bulunamadı.",
    "selectProfilePicture": "Profil Resmi Seç",
    "emailCannotBeChanged": "E-posta değiştirilemez",
    "phoneCannotBeChanged": "Telefon numarası değiştirilemez",
    "profileUpdated": "Profil başarıyla güncellendi",
    "nameRequired": "İsim gerekli",
    "updateError": "Profil güncellenirken hata oluştu",
    "details": "Detaylar",
    "transactionDetails": "İşlem Detayları",
    "transactionId": "İşlem ID",
    "transactionType": "İşlem Türü",
    "transactionDate": "İşlem Tarihi",
    "transactionAmount": "Tutar",
    "close": "Kapat",
    "title": "Başlık",
    "message": "Mesaj",

    // Statuses
    "Pending": "Beklemede",
    "Approved": "Onaylandı",
    "approved": "Onaylandı",
    "Rejected": "Reddedildi",
    "processed": "İşlendi",
    "InTransit": "Taşınıyor",
    "Delivered": "Teslim Edildi",
    "IssueFlagged": "Sorun Bildirildi",
    "Canceled": "İptal Edildi",
    "Transferred": "Aktarıldı",
    "Active": "Aktif",
    "active": "Aktif",
    "Paused": "Duraklatıldı",
    "Completed": "Tamamlandı",
    "Credit": "Kredi",
    "Withdrawal": "Para Çekme",
    "LostPackage": "Kayıp Paket",

    // New Features
    "transactions": "İşlemler",
    "allTransactions": "Tüm İşlemler",
    "officeTransactions": "Ofis İşlemleri",
    "officeCost": "Ofis Maliyeti",
    "officeCostOperations": "Ofis Mali İşlemleri",
    "officeCostContent": "Ofis maliyeti içeriği buraya eklenecek.",
    "kasa": "Kasa",
    "kasaContent": "Kasa içeriği buraya eklenecek.",
    "kasaHistory": "Kasa Geçmişi",
    "noKasaHistory": "Kasa geçmişi bulunamadı.",
    "type": "Tip",
    "insufficientKasaBalance": "Kasa bakiyesi yetersiz",
    "kullanicilarinKredileri": "Kullanıcnın hak ettiği kazanc",
    "onlyOfficeViewTransactions": "Sadece ofis kullanıcıları ofis işlemlerini görüntüleyebilir.",
    "activityLog": "Aktivite Günlüğü",
    "lostPackages": "Kayıp Paketler",
    "reportLostPackage": "Kayıp Paket Bildir",
    "supportingDocument": "Destekleyici Belge",
    "packageInformation": "Paket Bilgileri",
    "viewHistory": "Geçmişi Görüntüle",
    "showQR": "QR Göster",
    "qrPending": "QR Bekliyor",
    "qrCode": "QR Kod",
    "packageQRCode": "Paket QR Kodu",
    "noPackagesFound": "Paket Bulunamadı",
    "noTransactionsFound": "İşlem Bulunamadı",
    "noActivitiesFound": "Aktivite Bulunamadı",
    "accessDenied": "Erişim Reddedildi",
    "onlySuperAdmin": "Sadece Süper Admin erişebilir",
    "onlySuperAdminViewTransactions": "Sadece Süper Admin tüm işlemleri görüntüleyebilir",
    "onlySuperAdminViewActivityLog": "Sadece Süper Admin aktivite günlüğünü görüntüleyebilir",
    "onlySuperAdminManageBalances": "Sadece Süper Admin bakiyeleri yönetebilir",
    "totalTransactions": "Toplam İşlemler",
    "totalCredits": "Toplam Krediler",
    "totalWithdrawals": "hakettiği parayı aldığı tutar",
    "netAmount": "hak edip ama halen almadığı tutar",
    "allTypes": "Tüm Türler",
    "creditsOnly": "Sadece Krediler",
    "withdrawalsOnly": "Sadece Para Çekmeler",
    "searchByUser": "Kullanıcı, açıklama veya işlem ID ile ara...",
    "searchByActivity": "Kullanıcı, açıklama veya aktivite türü ile ara...",
    "totalActivities": "Toplam Aktiviteler",
    "approvals": "Onaylamalar",
    "deliveries": "Teslimatlar",
    "qrCodesGenerated": "Oluşturulan QR Kodlar",
    "allActivities": "Tüm Aktiviteler",
    "activityType": "Aktivite Türü",
    "performedBy": "Yapan",
    "targetUser": "Hedef Kullanıcı",
    "relatedPackage": "İlgili Paket",
    "relatedShipment": "İlgili Gönderi",
    "additionalDetails": "Ek Detaylar",
    "timestamp": "Zaman Damgası",
    "requestApproved": "Talep Onaylandı",
    "requestRejected": "Talep Reddedildi",
    "packageDelivered": "Paket Teslim Edildi",
    "qrGenerated": "QR Oluşturuldu",
    "statusChanged": "Durum Değiştirildi",
    "lostReportApproved": "Kayıp Rapor Onaylandı",
    "lostReportRejected": "Kayıp Rapor Reddedildi",
    "postCreated": "İlan Oluşturuldu",
    "postUpdated": "İlan Güncellendi",
    "userCreated": "Kullanıcı Oluşturuldu",
    "balanceAdjusted": "Bakiye Ayarlandı",
    "lostPackageReportApproved": "Kayıp paket raporu onaylandı - bakiye düşüldü",
    "lostPackageReportPending": "Kayıp paket raporu inceleme bekliyor",
    "cannotTransferPackage": "Paket aktarılamaz: Kayıp paket raporu onaylandı ve bakiye düşüldü",
    "warning": "Uyarı",
    "ifReportApproved": "Raporunuz onaylanırsa, paket değeri (${amount}) bakiyenizden düşülecektir.",
    "packageId": "Paket ID",
    "requestId": "Talep ID",
    "weight": "Ağırlık",
    "route": "Rota",
    "packageValue": "Paket Değeri",
    "processedRequests": "İşlenen Talepler",
    "reportedAt": "Bildirilme Tarihi",
    "reviewedAt": "İncelenme Tarihi",
    "adminNotes": "Admin Notları",
    "optional": "İsteğe Bağlı",
    "uploadPDF": "PDF, Word belgesi (.doc, .docx) veya metin dosyası (.txt) yükleyin. Maksimum boyut: 10MB",
    "clickToUpload": "Yüklemek için tıklayın veya sürükleyip bırakın",
    "orDragAndDrop": "veya sürükleyip bırakın",
    "takePicture": "Fotoğraf Çek",
    "maxFileSize": "PDF, DOC, DOCX, TXT (Maksimum 10MB)",
    "fileTooLarge": "Dosya boyutu 10MB'dan küçük olmalıdır",
    "attachment": "Ek",
    "viewAttachment": "Eki Görüntüle",
    "noOfficesFound": "Ofis bulunamadı",
    "maxSize": "PDF, DOC, DOCX veya TXT (MAKS. 10MB)",
    "submitting": "Gönderiliyor...",
    "submitReport": "Raporu Gönder",
    "lostPackageReportDetails": "Kayıp Paket Rapor Detayları",
    "reportId": "Rapor ID",
    "user": "Kullanıcı",
    "packageDetails": "Paket Detayları",
    "viewRequest": "Talep Görüntüle",
    "approveDeductBalance": "Onayla ve Bakiyeyi Düşür",
    "processing": "İşleniyor...",
    "totalUsers": "Toplam Kullanıcılar",
    "totalSystemBalance": "Toplam Sistem Bakiyesi",
    "transactionSummary": "İşlem Özeti",
    "creditExplanation": "Bu kredi, paketiniz teslim edildiğinde bakiyenize eklendi.",
    "withdrawalExplanation": "Bu tutar bakiyenizden düşüldü. Bu, kayıp paket raporu onayı veya başka bir yönetim işlemi nedeniyle olabilir.",
    "routeLabel": "Rota",
    "packageIdLabel": "Paket ID",
    "weightLabel": "Ağırlık",
    "pricePerKgLabel": "Kg başına fiyat",
    "packageValueLabel": "Paket Değeri",
    "statusLabel": "Durum",
    "lostPackageReport": "Kayıp Paket Raporu",
    "balanceDeducted": "Bakiye düşüldü",
    "kg": "kg",
    "receivedKg": "Alınan",
    "moreInfo": "Daha Fazla Bilgi",
    "userEmail": "Kullanıcı E-postası",
    "currentBalanceLabel": "Mevcut Bakiye",
    "actionsLabel": "İşlemler",
    "downloadFile": "Dosyayı İndir",
    "pleaseProvideDescription": "Lütfen bir açıklama girin",
    "failedToReportLostPackage": "Kayıp paket bildirimi başarısız oldu. Lütfen tekrar deneyin.",
    "pendingReportExists": "Bu paket için bekleyen bir rapor zaten mevcut",
    "role": "Rol",
    "system": "Sistem",
    "transferring": "Aktarılıyor...",
    "cannotTransferLostPackage": "Paket aktarılamaz: Kayıp paket raporu onaylandı ve bakiye düşüldü.",
    "showQRCodeToReceiver": "Bu QR kodunu alıcıya gösterin",
    "receiverInstructions": "Alıcı: Yukarıda gösterilen QR kodunu tarayın",
    "openCamera": "QR Kodu Taramak İçin Kamerayı Aç",
    "qrCodeScanned": "QR kodu başarıyla taranı!",
    "giverConfirmation": "Veren Onayı",
    "receiverConfirmation": "Alıcı Onayı",
    "confirmYouAreGiving": "Bu paketi verdiğinizi onaylayın",
    "confirmYouAreReceiving": "Bu paketi aldığınızı onaylayın",
    "scanQRCode": "QR Kodu Tara",
    "cameraAccessError": "Kameraya erişilemedi. Lütfen kamera izinlerine izin verin.",
    "packageNotForYou": "Bu paket size ait değil.",
    "invalidQRCode": "Geçersiz QR kodu formatı.",
    "receivePackage": "Paket Al",
    "scanQRCodeToReceive": "Paketi aktaran kişinin gösterdiği QR kodunu tarayın",
    "packageToReceive": "Alınacak Paket:",
    "receive": "Paketi Al",
    "packageAlreadyYours": "Bu paket zaten size ait.",
    "cannotReceiveLostPackage": "Kayıp olarak bildirilen bir paket alınamaz.",
    "packageNotFound": "Paket bulunamadı.",
    "confirmPackageTransfer": "Paket Transferini Onayla",
    "transferFrom": "Transfer Eden:",
    "unknownUser": "Bilinmeyen Kullanıcı",
    "pleaseConfirmTransfer": "Lütfen önce transferi onaylayın.",
    "waitingForConfirmation": "Lütfen onay ekranını bekleyin...",
    "completeTransfer": "Transferi Tamamla",
    "transferringTo": "Transfer Ediliyor:",
    "yourConfirmation": "Sizin Onayınız",
    "waiting": "Bekleniyor...",
    "transferCompleted": "Transfer tamamlandı! Paket kısa süre içinde aktarılacak.",
    "transferAlreadyPending": "Bu paket için zaten bekleyen bir transfer var.",
    "failedToCreateTransfer": "Transfer isteği oluşturulamadı.",
    "failedToCancelTransfer": "Transfer iptal edilemedi.",
    "transferredFrom": "Aktarıldı",
    "transferredTo": "Aktarıldı",
    "transferredAt": "Aktarım Tarihi",
    "transferredBy": "Aktaran",
    "scanQRCodeInstructions": "Taramak için kameranızı QR koduna doğrultun",
    "onlyOfficeCanAcceptPackage": "Bu QR kodunu oluşturan ofis paketi kabul edebilir.",
    "packageBelongsToDifferentOffice": "Paket Farklı Bir Ofise Ait",
    "packageBelongsToOfficeMessage": "Bu paket farklı bir ofise aittir ve burada kabul edilemez.",
    "thisPackageBelongsTo": "Bu paket şu ofise aittir",
    "pleaseContactCorrectOffice": "Lütfen bu paketi kabul etmek için doğru ofisle iletişime geçin.",
    "packageFound": "Paket Bulundu:",
    "confirm": "Onayla",
    "containerNumber": "Konteyner Numarası",
    "notSpecified": "Belirtilmemiş",
    "activePackages": "Aktif Paketler",
    "archive": "Arşiv",
    "archived": "Arşivlendi",
    "noActivePackages": "Aktif Paket Yok",
    "noActivePackagesDescription": "Şu anda aktif paketiniz bulunmuyor.",
    "noArchivedPackages": "Arşivlenmiş Paket Yok",
    "noArchivedPackagesDescription": "Arşivlenmiş paketiniz bulunmuyor.",
    "inTransit": "Yolda",
    "delivered": "Teslim Edildi",
    "workerActions": "Çalışan İşlemleri",
    "approvedBy": "Onaylayan",
    "acceptedBy": "Kabul Eden",
    "qrGeneratedBy": "QR Oluşturan",
    "deliveredBy": "Teslim Alan",
    "info": "Bilgi",
    "postDetails": "İlan Detayları",
    "shipmentInformation": "Gönderi Bilgileri",
    "shipment": "Gönderi",
    "viewDetails": "Detayları Gör",
    "customers": "Müşteriler",
    "noCustomers": "Bu ilan için henüz müşteri yok.",
    "scanDate": "Taranma Tarihi",
    "dateTime": "Tarih ve Saat",
    "delete": "Sil",
    "deleteSeller": "Tüccarı Sil",
    "deleteProduct": "Ürünü Sil",
    "deletePost": "İlanı Sil",
    "confirmDelete": "Silmeyi Onayla",
    "confirmDeleteSeller": "Bu tüccarı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    "confirmDeleteProduct": "Bu ürünü silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    "confirmDeletePost": "Bu ilanı silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.",
    "deletedSuccessfully": "Başarıyla silindi",
    "failedToDelete": "Silme işlemi başarısız oldu. Lütfen tekrar deneyin.",
    "yes": "Evet",
    "no": "Hayır",
    "areYouSure": "Emin misiniz?",
    "name": "İsim",
    "createdAt": "Oluşturulma Tarihi",
    "enterEmail": "E-posta adresinizi girin",
    "create": "Oluştur",
    "creating": "Oluşturuluyor...",
    "fillAllFields": "Lütfen tüm gerekli alanları doldurun",
    "emailAlreadyExists": "E-posta zaten mevcut",
    "amount": "Tutar",
    "addIncome": "Gelir Ekle",
    "withdraw": "Para Çek",
    "pleaseEnterValidAmount": "Lütfen geçerli bir tutar girin",
    "failedToWithdraw": "Para çekme başarısız oldu",
    "failedToAddIncome": "Gelir ekleme başarısız oldu",
    "balanceByOffice": "Ofise Göre Bakiye",
    "noBalanceAvailable": "Çekim için kullanılabilir bakiye yok",
    "insufficientBalance": "Yetersiz bakiye",
    "pendingWithdrawalExists": "Bu ofis için zaten bekleyen bir para çekme talebiniz var",
    "noBalanceForOffice": "Bu ofis için kullanılabilir bakiye yok",
    "noShipmentsFound": "Gönderi bulunamadı",
    "noPostsFound": "İlan bulunamadı",
    "postNotFound": "İlan bulunamadı",
    "print": "Yazdır",
    "loadingPackageInformation": "Paket bilgileri yükleniyor...",
    "error": "Hata",
    "packageInfoNotFound": "Paket bilgisi bulunamadı.",
    "statusHistory": "Durum Geçmişi",
    "packageInfoConfidentialNote": "Bu belge gizli paket bilgileri içermektedir.",
    "exportPdf": "PDF Olarak Dışa Aktar",
    "customerInformation": "Müşteri Bilgileri",
    "imageUploadHint": "PNG, JPG, GIF (maksimum 10MB)",
    "date": "Tarih",
    "noSellersFound": "Tüccar bulunamadı",
    "remainingPieces": "Kalan Adet",
    "requestApproval": "Hesap Onayı İste",
    "approvalRequired": "Hesap Onayı Gerekli",
    "approvalRequiredDescription": "Hesabınızın uygulamayı kullanmadan önce bir ofis tarafından onaylanması gerekiyor. Lütfen bir ofis seçin ve onay talebi gönderin.",
    "submitApprovalRequest": "Onay Talebi Gönder",
    "selectAnOffice": "Bir ofis seçin...",
    "pleaseSelectOffice": "Lütfen bir ofis seçin",
    "pendingRequestExists": "Bu ofis için zaten bekleyen bir talebiniz var",
    "pendingRequestForOffice": "Bu ofis için zaten bekleyen bir talebiniz var",
    "errorSubmittingRequest": "Talep gönderilirken hata oluştu",
    "requestSubmittedSuccessfully": "Talep başarıyla gönderildi! Ofis talebinizi inceleyecek.",
    "messagePlaceholder": "Talebinizle birlikte eklemek istediğiniz ek bilgileri ekleyin...",
    "submitRequest": "Talebi Gönder",
    "myApprovalRequests": "Onay Taleplerim",
    "submitted": "Gönderildi",
    "reviewed": "İncelendi",
    "shortageDelivery": "Eksik Teslimat",
    "missingWeight": "Eksik Ağırlık",
    "deductFromBalance": "Bakiyeden Düş",
    "putOnHold": "Beklemeye Al",
    "deliverMissingWeight": "Eksik Miktarı Teslim Et",
    "shortageDeliveryNotification": "Eksik teslimat bildirimi: {missingKg} kg eksik",
    "selectAction": "Aksiyon Seçin",
    "waitingForMissingWeight": "Eksik miktar bekleniyor",
    "missingWeightDelivered": "Eksik miktar teslim edildi",
    "payUpfront": "Peşin Öde",
    "mutualApprovalRequired": "Karşılıklı onay gerekli",
    "shortageDeliveryDetails": "Eksik Teslimat Detayları",
    "requestedWeight": "Talep Edilen Ağırlık",
    "missingAmount": "Eksik Miktar",
    "shortageStatus": "Durum",
    "sendingOffice": "Paketi Veren Ofis",
    "receivingOffice": "Paketi Teslim Alan Ofis",
    "actionTaken": "Alınan Aksiyon",
    "missingKgDelivered": "Teslim Edilen Eksik Miktar",
    "deliveredAt": "Teslim Tarihi",
    "finalAction": "Son Aksiyon",
    "noShortageDeliveries": "Eksik teslimat bulunamadı",
    "enterMissingWeight": "Eksik miktarı girin (kg)",
    "deliver": "Teslim Et",
    "cannotDeliverMoreThanMissing": "Teslim edilen miktar eksik miktardan fazla olamaz",
    "shortageActionConfirmation": "Bu aksiyonu onaylıyor musunuz?",
    "deductConfirmation": "Eksik miktar bakiyeden düşülecek. Devam etmek istiyor musunuz?",
    "holdConfirmation": "Paket beklemeye alınacak ve eksik miktar getirilmesi beklenilecek. Devam etmek istiyor musunuz?",
    "finalActionConfirmation": "Bu son aksiyonu onaylıyor musunuz?",
    "pending": "Beklemede",
    "onHold": "Beklemeye Alındı",
    "paidUpfront": "Peşin Ödendi",
    "completed": "Tamamlandı",
    "rejected": "Reddedildi",
    "selectShortageAction": "Eksik miktar için nasıl işlem yapmak istersiniz?",
    "qrCodeWarning": "Bu belge taranmış bir QR kodundan oluşturuldu. İşlemeden önce lütfen tüm bilgileri doğrulayın.",
    "createManualPackage": "Manuel Paket Oluştur",
    "createAndGenerateQR": "Oluştur ve QR Kodu Oluştur",
    "enterWeight": "Ağırlığı girin (kg)",
    "requestedPieces": "İstenen Adet",
    "requestedKg": "İstenen Ağırlık (kg)",
    "pleaseEnterValidWeight": "Lütfen geçerli bir ağırlık girin",
    "pleaseEnterNameAndPhone": "Lütfen isim ve telefon numarası girin",
    "errorCreatingPackage": "Paket oluşturulurken hata oluştu",
    "packageCreatedSuccessfully": "Paket başarıyla oluşturuldu!",
    "qrCodeGenerated": "QR kodu oluşturuldu ve paket hazır.",
    "bagNumber": "Çuval Numarası",
    "enterBagNumber": "Çuval numarasını girin",
    "manageNotifications": "Bildirim Yönetimi",
    "sendNotification": "Bildirim Gönder",
    "notificationTitle": "Bildirim başlığı",
    "notificationMessage": "Bildirim mesajı",
    "target": "Hedef",
    "sending": "Gönderiliyor...",
    "notifications": "Bildirimler",
    "unread": "okunmamış",
    "noNotifications": "Bildirim yok",
    "markAsRead": "Okundu olarak işaretle",
    "justNow": "Şimdi",
    "minutesAgo": "dakika önce",
    "hoursAgo": "saat önce",
    "daysAgo": "gün önce",
    "userApprovals": "Kullanıcı Onayları",
    "more": "Daha Fazla",
    "packageRequestApproved": "Paket talebi onaylandı",
    "packageRequestRejected": "Paket talebi reddedildi",
    "packageMarkedAsDelivered": "Paket teslim edildi olarak işaretlendi",
    "qrCodeGeneratedForPackage": "Paket için QR kodu oluşturuldu",
    "packageCanceledLostReportApproved": "Paket iptal edildi - kayıp bildirimi onaylandı",
    "packageTransferredToAnotherUser": "Paket başka bir kullanıcıya devredildi",
    "packageStatusChangedTo": "Paket durumu değiştirildi",
    "package": "Paket",
    "lostPackageReportRejected": "Kayıp paket bildirimi reddedildi",
    "shipmentPostCreated": "Kargo ilanı oluşturuldu",
    "lost": "Kayıp",
    "post": "İlan",
    "errorProcessingRequest": "Talep işlenirken hata oluştu",
    "unknownOffice": "Bilinmeyen Ofis",
    "approveUserRequest": "Kullanıcı Talebini Onayla",
    "rejectUserRequest": "Kullanıcı Talebini Reddet",
    "noProcessedRequests": "İşlenmiş talep bulunmuyor",
    "noPaymentsFound": "Ödeme bulunamadı",
    "productDetails": "Ürün Detayları",
    "productInformation": "Ürün Bilgileri",
    "archivedAt": "Arşivlenme Tarihi",
    "manageUserApprovals": "Kullanıcı Onaylarını Yönet",
    "enterWorkerName": "Çalışan adını girin",
    "searchTransactions": "İşlemlerde ara...",
    "amountExceedsDebt": "Tutar kalan borcu aşıyor",
    "pleaseEnterDescription": "Lütfen açıklama girin",
    "failedToMarkDelivered": "Teslim edildi olarak işaretlenemedi",
    "failedToGeneratePdf": "PDF oluşturulamadı",
    "generatedOn": "Oluşturulma tarihi",
    "withdrawal": "Para Çekme",
    "lostPackage": "Kayıp Paket",
    "currency": "Para Birimi",
    "cameraNotSupported": "Kamera bu cihazda desteklenmiyor",
    "cameraRequiresHttps": "Kamera erişimi güvenli bağlantı (HTTPS) gerektirir",
    "swapLocations": "Konumları değiştir"
  }
};

export const COUNTRIES = {
  'tr': 'Turkey',
  'iq': 'Iraq'
};
